// Call recording + consent notice on Telnyx calls (plan B4): admin settings and the authenticated playback of a stored
// recording (streamed by the API from private storage — never a provider URL).
import { z } from 'zod';
import * as R from './api-recording.js';
import { IdParam, route, W, Ws } from './route-def.js';

/** Binary download: the handler streams the file (attachment, nosniff); errors still use the JSON envelope. */
const Binary = z.unknown();

export const recordingRoutes = {
  getCallRecordingSettings: route({
    method: 'GET', path: '/workspaces/:workspaceId/call-recording/settings', summary: 'Grabación de llamadas: activación por tipo de llamada y aviso de consentimiento', tag: 'calls',
    minRole: 'admin', params: Ws, response: R.CallRecordingSettingsSchema,
  }),
  updateCallRecordingSettings: route({
    method: 'PUT', path: '/workspaces/:workspaceId/call-recording/settings', summary: 'Actualizar la grabación de llamadas y el aviso de consentimiento (auditado)', tag: 'calls',
    minRole: 'admin', params: Ws, body: R.UpdateCallRecordingSettingsSchema, response: R.CallRecordingSettingsSchema,
  }),
  downloadCallRecording: route({
    method: 'GET', path: '/workspaces/:workspaceId/calls/:callId/recording/audio', summary: 'Audio de la grabación guardada en LIA (requiere permiso de grabaciones)', tag: 'calls',
    minRole: 'advisor', params: W({ callId: IdParam }), response: Binary, produces: 'application/octet-stream',
  }),
} as const;
